import { useEffect } from "react";
import { toast } from "sonner";
import { MAX_MB, extsDeAccept, validarArchivo } from "@/lib/archivos";

// Candado universal de archivos (sep-2026). Escucha en fase de captura el `change` de
// CUALQUIER <input type="file"> de la aplicación: si el archivo excede el tope o su tipo no
// está permitido, corta el evento antes de que llegue al handler de la pantalla, limpia el
// input y muestra el mensaje único. Así ningún punto de carga puede olvidarse de validar.
// El tope por defecto es 10 MB; un input puede pedir otro con data-max-mb="25".
export function GuardaArchivos() {
  useEffect(() => {
    const onChange = (e) => {
      const el = e.target;
      if (!el || el.tagName !== "INPUT" || el.type !== "file") return;
      const files = Array.from(el.files || []);
      if (!files.length) return;
      const maxMB = Number(el.dataset?.maxMb) || MAX_MB;
      const exts = extsDeAccept(el.accept);
      for (const f of files) {
        const error = validarArchivo(f, { maxMB, exts });
        if (error) {
          e.stopImmediatePropagation();
          e.preventDefault();
          el.value = "";
          toast.error(error, { duration: 6000 });
          return;
        }
      }
    };
    document.addEventListener("change", onChange, true);
    return () => document.removeEventListener("change", onChange, true);
  }, []);
  return null;
}
